import React, { useContext, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import Lottie from "lottie-react";
import login from './../../Images/62773-yoga-developer.json'
import { AuthContext } from '../../Providers/AuthProviders'
import { saveUser } from '../../API/auth';

function Login() {
    const [show, setShow] = useState(false)
    const { loginUser, googleLogin } = useContext(AuthContext)
    const navigate = useNavigate();
    const location = useLocation();

    const from = location.state?.from?.pathname || '/';

    const handleLogin = (e) => {
        e.preventDefault();

        const form = e.target;
        const email = form.email.value;
        const password = form.password.value;

        loginUser(email, password)
            .then((userCredential) => {
                // Signed in 
                navigate(from, { replace: true })
            })
            .catch((error) => {
                
            });
    }

    const handleGoogleLogin = () => {
        googleLogin()
            .then((result) => {
                const user = result.user;
                saveUser(user)
                navigate(from, { replace: true })
            }).catch((error) => {
                
            });
    }

    return (
        <section className="py-16 relative flex justify-center flex-wrap lg:items-center">
            <div className="lg:ms-28 w-full px-4 py-8 sm:px-6 sm:py-16 lg:px-8 lg:py-16 lg:w-96">
                <div className="mx-auto max-w-lg text-center">
                    <h2 className='text-center py-5 text-3xl text-green-400 font-extrabold'>Login</h2>
                </div>

                <form onSubmit={handleLogin}>
                    <div className="relative">
                        <input type="email" name="email" id="floating_outlined" className="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border-1 border-green-500 appearance-none  focus:outline-none focus:ring-0 focus:border-green-500 peer mb-6" placeholder=" " required />
                        <label htmlFor="floating_outlined" className="absolute text-md text-green-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-teal-950 px-2 peer-focus:px-2 peer-focus:text-green-500 peer-focus:dark:text-green-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Enter Email</label>
                    </div>

                    <div className="relative">
                        <input type={show ? "text" : "password"} name="password" id="floating_outlined" className="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border-1 border-green-500 appearance-none  focus:outline-none focus:ring-0 focus:border-green-500 peer" placeholder=" " required />
                        <label htmlFor="floating_outlined" className="absolute text-md text-green-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-teal-950 px-2 peer-focus:px-2 peer-focus:text-green-500 peer-focus:dark:text-green-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Password</label>
                    </div>

                    <p className='m-0 underline cursor-pointer inline-block dark:text-white' onClick={() => setShow(!show)}>
                        <small>
                            {
                                show ? <span>Hide Password</span> :
                                    <span>Show Password</span>
                            }
                        </small>
                    </p>
                    <br />
                    <div className='flex justify-center'>
                        <button className='bg-green-400 mx-auto text-white py-3 px-6 mt-6 font-bold rounded-full hover:bg-green-600' type="submit">Sign in</button>
                    </div>

                </form>
                <p className='mt-3 text-center text-lg font-semibold text-gray-400'>Demo Credentials</p>
                <div className='flex flex-col justify-between items-center'>
                <p className='text-gray-400 text-xs'>email: student@gmail.com pass:123456</p>
                <p className='text-gray-400 text-xs'>email: instructor@gmail.com pass:123456</p>
                <p className='text-gray-400 text-xs'>email: admin@yogacampers.com pass:123456</p>
                </div>
                <hr className='border border-green-500 opacity-50 my-4' />
                <p className='text-center dark:text-white'><small>Or Sign in With</small></p>
                <button
                    type="button"
                    onClick={handleGoogleLogin}
                    className="w-full mt-2 py-3 px-4 inline-flex justify-center items-center gap-x-2 text-sm font-medium rounded-lg border border-green-200 text-neutral-800 shadow-sm hover:bg-green-50 disabled:opacity-50 disabled:pointer-events-none dark:text-white dark:hover:bg-transparent"
                >
                    <svg
                    className="w-4 h-auto"
                    width="46"
                    height="47"
                    viewBox="0 0 46 47"
                    fill="none"
                    >
                    <path
                        d="M46 24.0287C46 22.09 45.8533 20.68 45.5013 19.2112H23.4694V27.9356H36.4069C36.1429 30.1094 34.7347 33.37 31.5957 35.5731L31.5663 35.8669L38.5191 41.2719L38.9885 41.3306C43.4477 37.2181 46 31.1669 46 24.0287Z"
                        fill="#4285F4"
                    />
                    <path
                        d="M23.4694 47C29.8061 47 35.1161 44.9144 39.0179 41.3012L31.625 35.5437C29.6301 36.9244 26.9898 37.8937 23.4987 37.8937C17.2793 37.8937 12.0281 33.7812 10.1505 28.1412L9.88649 28.1706L2.61097 33.7812L2.52296 34.0456C6.36608 41.7125 14.287 47 23.4694 47Z"
                        fill="#34A853"
                    />
                    <path
                        d="M10.1212 28.1413C9.62245 26.6725 9.32908 25.1156 9.32908 23.5C9.32908 21.8844 9.62245 20.3275 10.0918 18.8588V18.5356L2.75765 12.8369L2.52296 12.9544C0.909439 16.1269 0 19.7106 0 23.5C0 27.2894 0.909439 30.8731 2.49362 34.0456L10.1212 28.1413Z"
                        fill="#FBBC05"
                    />
                    <path
                        d="M23.4694 9.07688C27.8699 9.07688 30.8622 10.9863 32.5344 12.5725L39.1645 6.11C35.0867 2.32063 29.8061 0 23.4694 0C14.287 0 6.36607 5.2875 2.49362 12.9544L10.0918 18.8588C11.9987 13.1894 17.25 9.07688 23.4694 9.07688Z"
                        fill="#EB4335"
                    />
                    </svg>
                    Sign in with Google
                </button>

                <p className='text-center dark:text-white'><small>Don't have an account? <Link to="/signup"> <span className="text-green-500">Signup</span></Link></small></p>
            </div>

            <div className="relative h-64 sm:h-96 lg:h-full lg:w-1/3">
                <Lottie animationData={login} loop={true} />
            </div>
        </section>
    )
}

export default Login